(function () {
    var page = document.querySelector('[data-policy-page]');
    if (!page || page.dataset.policyInit) return;
    page.dataset.policyInit = 'true';

    var trigger = page.querySelector('[data-policy-mobile-trigger]');
    var sidebar = page.querySelector('[data-policy-sidebar]');
    var backdrop = page.querySelector('[data-policy-mobile-backdrop]');
    var closeBtn = page.querySelector('[data-policy-mobile-close]');

    function openSidebar() {
      sidebar.classList.add('is-open');
      backdrop.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    }

    function closeSidebar() {
      sidebar.classList.remove('is-open');
      backdrop.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }

    if (trigger && sidebar && backdrop) {
      trigger.addEventListener('click', function () {
        if (sidebar.classList.contains('is-open')) {
          closeSidebar();
        } else {
          openSidebar();
        }
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', closeSidebar);
      }

      backdrop.addEventListener('click', closeSidebar);

      window.addEventListener('resize', function () {
        if (window.innerWidth > 989) {
          closeSidebar();
        }
      });
    }

    // Measure the actual rendered height of sticky-header at click time,
    // so leftover content from the previous section never peeks above the target
    function getHeaderOffset() {
      var header = document.querySelector('sticky-header');
      return header ? header.getBoundingClientRect().height : 0;
    }

    // How long to wait after click before measuring positions, so layout
    // (closing mobile sidebar, lazy images, etc.) has settled first.
    // Adjust this if the scroll still lands off-target.
    var ANCHOR_SCROLL_DELAY = 100;

    var anchorLinks = page.querySelectorAll('[data-policy-anchor-link]');
    anchorLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href');
        var hashIndex = href.indexOf('#');
        if (hashIndex === -1) return;

        var targetId = href.slice(hashIndex + 1);
        var target = document.getElementById(targetId);
        if (!target) return;

        event.preventDefault();

        setTimeout(function () {
          // Service center sections link to the wrapper div; scroll to the
          // subheading inside it (if any) so the header lines up with the
          // h2 itself instead of stopping above it.
          var subheading = target.querySelector('.policy-page__subheading');
          var scrollTarget = subheading || target;

          var headerOffset = getHeaderOffset();
          var targetTop = scrollTarget.getBoundingClientRect().top + window.pageYOffset - headerOffset - 10;

          window.scrollTo({
            top: targetTop,
            behavior: 'smooth'
          });
        }, ANCHOR_SCROLL_DELAY);
      });
    });

    var currentUrl = window.location.pathname + window.location.search;
    var navItems = page.querySelectorAll('.policy-page__nav-item');
    navItems.forEach(function (item) {
      var link = item.querySelector('.policy-page__nav-link');
      if (!link) return;
      var linkUrl = link.getAttribute('href');
      if (linkUrl === currentUrl) {
        item.classList.add('is-active');
      } else {
        item.classList.remove('is-active');
      }
    });
  })();